export const FETCH_BATCH_JOBS = 'batchJobs/FETCH_BATCH_JOBS'
export const FETCH_BATCH_JOBS_STARTED = 'batchJobs/FETCH_BATCH_JOBS_STARTED'
export const FETCH_BATCH_JOBS_SUCCESS = 'batchJobs/FETCH_BATCH_JOBS_SUCCESS'
export const FETCH_BATCH_JOBS_FAILED = 'batchJobs/FETCH_BATCH_JOBS_FAILED'

export const START_BATCH_JOBS_POLLING = 'batchJobs/START_BATCH_JOBS_POLLING'
